import { render } from "./InsuranceContact.vue?vue&type=template&id=1b130bab&scoped=true"
import script from "./InsuranceContact.vue?vue&type=script&lang=js"
export * from "./InsuranceContact.vue?vue&type=script&lang=js"

import "./InsuranceContact.vue?vue&type=style&index=0&id=1b130bab&scoped=true&lang=css"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b130bab"]])

export default __exports__